<template>
  <div class="shopping-container" :class="showShopping ? 'right' : ''">
    <div class="close" @click="closeShoppingList">
      <Icon type="close-round" class="icon"></Icon>
    </div>
    <div class="content">
      <div class="cart-title">购物车 ({{ this.shoppingCart.length }})</div>
      <div class="tip">
        <router-link to="/shoppingCart" class="look"
          >查看购物车全部产品>>></router-link
        >
      </div>
      <div class="project" :style="{ height: height + 'px' }">
        <div class="item" v-for="item of shoppingCart" :key="item.id">
          <div class="left">
            <img :src="item.productInfo.image" alt="" />
          </div>
          <div class="right">
            <div class="name l-height">{{ item.productInfo.store_name }}</div>
            <div class="ot-price l-height">
              单价：￥{{ item.productInfo.ot_price }}
            </div>
            <div class="input-box l-height">
              <div class="input">
                <InputNum
                  :max="item.productInfo.stock"
                  @on-change="changeCount"
                  :id="item.id"
                  :num="item.cart_num"
                ></InputNum>
              </div>
              <div class="last-price">￥{{ item.truePrice }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="commit">
        <div>购物车内{{ this.shoppingCart.length }}件商品</div>
        <div>
          总价：<span>￥{{ totalPrice }}</span>
        </div>
        <div class="btn" @click="goCart">去购物车结算</div>
      </div>
    </div>
  </div>
</template>

<script>
import InputNum from "@/components/pc/commonTool/InputNum";
import { changeCartNum } from "@api/store";
import { getCartList } from "@api/user";
export default {
  name: "ShoppingList",
  props: ["showShopping"],
  components: { InputNum },
  data() {
    return {
      shoppingCart: [],
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
      height: document.documentElement.clientHeight - 110 - 54 - 26
    };
  },
  computed: {
    totalPrice() {
      let total = 0;
      this.shoppingCart.forEach(element => {
        total += element.cart_num * element.truePrice;
      });
      return total.toFixed(2);
    }
  },
  watch: {
    screenHeight(val) {
      this.height = val - 110 - 54 - 26;
    },
    showShopping: {
      handler() {
        if(this.showShopping){
        this.getCartListInfo();
        }
      },
      immediate: true
    }
  },
  created() {
    if(this.showShopping){
    this.getCartListInfo();
    }
  },
  mounted() {
    window.onresize = () => {
      // 定义窗口大小变更通知事件
      this.screenHeight = document.documentElement.clientHeight; // 窗口高度
    };
  },
  methods: {
    closeShoppingList() {
      this.$parent.showShopping = false;
    },
    changeCount(index, id) {
      this.changeCartNumber(index, id);
    },
    goCart() {
      this.$router.push("/shoppingCart");
    },
    changeCartNumber(number, id) {
      changeCartNum(id, number).then(() => {
        this.getCartListInfo();
      });
    },
    getCartListInfo() {
      getCartList().then(res => {
        this.$set(this, "shoppingCart", res.data.valid);
      });
    }
  }
};
</script>

<style lang="stylus" scoped>

.shopping-container
  width 265px
  height 100%
  border-left 2px solid #4389ff
  background #f5f5f5
  position fixed
  top 0
  right -295px
  transition right 0.5s linear;
  z-index 1000
  &.right
    right 0
  .close
    position absolute
    top 0
    left -30px
    background #4389ff
    width 30px
    height 30px
    display flex
    justify-content center
    align-items center
    cursor pointer
    .icon
      font-size 16px
      color #fff
      text-align center
  .content
    .cart-title
      height 54px
      background #e7f2ff
      line-height 54px
      color #4389ff
      text-align center
      font-size 20px
      border-bottom 1px solid #4389ff
    .tip
      line-height 26px
      text-align center
      font-family '宋体'
      .look
        color #888
    .project
      margin-right 5px
      overflow-y auto
      &::-webkit-scrollbar
        width 7px
      &::-webkit-scrollbar-thumb
        background #aad9ef
        -webkit-border-radius 10px
        -moz-border-radius 10px
        border-radius 10px
      .item
        background #fff
        display flex
        padding 15px
        margin-bottom 10px
        font-family '宋体'
        .left
          width 70px
          height 70px
          margin-right 10px
          img
            width 100%
            height 100%
        .right
          flex 1
          .l-height
            height 22px
            line-height 22px
            overflow hidden
            padding-right 10px
            color #666
          .input-box
            display flex
            margin-top 2px
            .input
              margin-top 3px
            .last-price
              margin-left 10px
              font-family Verdana
              color #ff5c4d
    .commit
      height 110px
      padding 15px
      div:not(:last-child)
        height 22px
        line-height 22px
        color #555
        span
          font-family 'Arial, Helvetica, sans-serif'
          color #ff5c4d
          font-weight 550
      .btn
        line-height 35px
        height 35px
        color #ffffff
        background #ff5c4d
        text-align center
        font-size 16px
        border-radius 4px
        margin-top 5px
        cursor pointer
</style>
